/**
 * Prefer the org's current `soid` from the logged-in session for invite / success copy,
 * so the UI matches the org profile even if the API echoed an older @suffix.
 */
export function displayTeamInviteUsername(
  apiUsername: string,
  sessionSoid?: string | null
): string {
  const soid = sessionSoid?.trim();
  if (!soid || !apiUsername.includes("@")) {
    return apiUsername;
  }
  const local = apiUsername.split("@")[0]!.trim();
  return `${local.toLowerCase()}@${soid}`;
}
